<div class="{{(field.containerClass ? field.containerClass : 'col-md-6 d-inline-flex mb-4')}}">
    <div [formGroup]="group">
        <label style="font-size: 13px;font-weight: 600;">{{field.label}}</label>
        <label *ngIf="field.required" class="text-danger">*</label>
        <div *ngFor="let v of field.options" class="inline-form-group">
            <label class="cust-check-bx">
                <input [ngClass]="{'disabled': field.disabled}" [disabled]="field.disabled" type="radio" [formControlName]="field.name" [value]="v.value"> {{v.label}}
            </label>
        </div>
        <div *ngFor="let validation of field.validations">
            <div *ngIf="group.get(field.name).invalid && (group.get(field.name).dirty || group.get(field.name).touched)"
                class="text-danger">
                <small *ngIf="group.get(field.name).errors">
                    <b>
                        *{{validation.message}}
                    </b>
                </small>
            </div>
        </div>
    </div>
</div>